var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModernTable',{attrs:{"users-table":"","columns":_vm.columns,"rows":_vm.rows,"filters":{
    show: false
  },"focusable":true,"selected":_vm.selected,"condensed":"","rowOnClick":_vm.rowOnClick},on:{"update:selected":function($event){_vm.selected=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }